<div scrollY="true">
	<div style="display: grid; grid-template-columns: 1fr 1fr; width: 100%; margin-top: 5px;">
			@if (mikrotikStatusesRow1.length == 0) {
			<app-skeleton-loader [height]="5"></app-skeleton-loader>
			}
			@if (mikrotikStatusesRow1.length > 0) {
			<app-data-tile-list title="" titleColor="primary" statusColor="medium" [dataTiles]="mikrotikStatusesRow1">
			</app-data-tile-list>
			}
			@if (mikrotikHealth == null) {
			<app-skeleton-loader [height]="5"></app-skeleton-loader>
			}
			@if (mikrotikHealth != null) {
			<app-progress-tile title="Overall Group Router Health" [lowerLimit]="0" [upperLimit]="100"
				[fixedPercentage]="mikrotikHealth.Health"></app-progress-tile>
			}
	</div>
	<div style="display: grid; grid-template-columns: 1fr 1fr; width: 100%;">
			@if (mikrotikStatusesRow2.length == 0) {
			<app-skeleton-loader [height]="5"></app-skeleton-loader>
			}
			@if (mikrotikStatusesRow2.length > 0) {
			<app-data-tile-list title="" titleColor="primary" statusColor="medium" [dataTiles]="mikrotikStatusesRow2">
			</app-data-tile-list>
			}
			@if (activeDeviceHistory.length == 0) {
			<app-skeleton-loader [height]="5"></app-skeleton-loader>
			}
			@if (activeDeviceHistory.length > 0) {
			<app-data-tile-list title="Device Activity Breakdown" titleColor="primary"
				[segementedTiles]="activeDeviceHistory" [segmentedTile]="true">
			</app-data-tile-list>
			}
	</div>
	<huge-row class="mat-align-items-end">
		<mat-col>
			@if (devicesOverTimeData == null) {
			<app-skeleton-loader [height]="12"></app-skeleton-loader>
			}
			@if (devicesOverTimeData != null) {
			<app-data-device-over-time-chart [data]="devicesOverTimeData" (daterangeStart)="startDateInput($event)"
				(daterangeEnd)="endDateInput($event)" (timeFrame)="timeFrameChange($event)"
				[defaultTimeFrame]="currTimeFrame" (monthlyToggleChanged)="monthlyToggleChanged()"
				(dailyToggleChanged)="dailyToggleChanged()" [monthlyToggle]="monthlyToggle" [dailyToggle]="dailyToggle"
				[defaultStart]="daterangeStart" [defaultEnd]="daterangeEnd" [isMikrotik]="true">
			</app-data-device-over-time-chart>
			}
		</mat-col>
	</huge-row>
</div>